import { Link } from 'react-router-dom';
import { brandInfo } from '@/mocks/articles';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20fluid%20waves%20with%20deep%20navy%20blue%20and%20soft%20teal%20gradients%2C%20smooth%20flowing%20curves%2C%20minimalist%20digital%20art%2C%20clean%20modern%20background%2C%20elegant%20dark%20blue%20composition%20with%20subtle%20light%20accents%2C%20sophisticated%20tech%20atmosphere%2C%20no%20text%20no%20people%2C%20abstract%20geometric%20flow&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-900/50 to-primary-950/80"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 py-20 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
          <span className="text-sm text-background-50/90 font-medium">v2.4 版本已发布 · 性能提升 40%</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6">
          精致轻量的
          <br />
          <span className="text-accent-400">蓝色小导航</span> 解决方案
        </h1>

        <p className="text-base md:text-lg text-background-50/75 max-w-2xl mx-auto mb-10 leading-relaxed">
          简洁高效的轻量级导航组件，清晰的蓝色视觉风格与灵活的布局方案。
          无论是网站顶部导航、侧边栏还是移动端菜单，快速集成、轻松定制。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/quick-start"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-rocket-line text-lg"></i>
            快速入门
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/25 text-background-50 font-semibold text-sm hover:bg-background-50/20 transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-information-line text-lg"></i>
            了解我们
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-3 gap-8 max-w-lg mx-auto">
          {brandInfo.stats.map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50">{stat.value}</div>
              <div className="text-xs md:text-sm text-background-50/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}